import { colors, spacing, borderRadius, shadows } from '../styles/styles';

export const floatingActionButtonStyles = {
  button: {
    position: 'fixed',
    bottom: spacing.xl,
    right: spacing.xl,
    width: '56px',
    height: '56px',
    borderRadius: borderRadius.circle,
    backgroundColor: colors.surface,
    color: colors.accent.white,
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: shadows.md,
    cursor: 'pointer',
  },
  icon: {
    stroke: colors.accent.white,
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  }
}; 